import { fontStyleHeadings2 } from "components/Common/styles.js";

export const issuesReportedStyles = {
  issuesReportedSummaryHeadingContainer: {
    default: {
      padding: "30px 0px 30px 15px",
    },
    retro: { padding: "30px 0px 0px 15px" },
    electric: { padding: "30px 0px 0px 15px" },
  },
  issuesReportedSummaryHeadingStyle: fontStyleHeadings2,
};



// WEBPACK FOOTER //
// ./src/components/IssuesReports/styles/IssuesReportedPageStyle.js